import { Box } from "theme-ui";

export default function EmptyImageCrossIcon(props) {
  return (
    <Box
      as="svg"
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0.5 0L50.5 50M50.5 0L0.5 50" stroke="#CCCCCC" />
    </Box>
  );
}
